import styled from 'styled-components';

export const MainTableContainer = styled.div`
  width: 100%;
  .ant-table-content .ant-table-tbody .ant-table-expanded-row td > div > div {
    display: block;
  }
  tr.ant-table-expanded-row > td {
    padding: 0;
  }
`;

export const TableRowContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 2fr auto;
`;

export const TableRowEdit = styled.div`
  width: 100%;
  display: flex;
  color: ${({ theme }) => theme.colors.primary.blue};
`;
